import { SVGProps } from "react";

export interface IconProps extends SVGProps<SVGSVGElement> {}

export interface ModalProps {
  open: boolean;
  onClose: () => void;
}

export interface GeneralReponse<T> {
  status: "success" | "error";
  code: null;
  message: string;
  detail: string;
  data: T;
}

export interface Pagination<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

export interface LimitOffset {
  limit: number;
  offset: number;
}

export interface Picture {
  large: string;
  medium: string;
  small: string;
  thumb: string;
  original: string;
}

export interface PictureResized {
  original: string;
  resized: string;
}

export interface PosterH extends Picture {
  promo: string;
  resized: string;
}

export interface Content {
  id: number;
  is_serial: boolean;
  is_free: boolean;
  is_soon: boolean;
  is_new: boolean;
  is_russian: boolean;
  poster_h: PosterH;
  rating: number;
  title: string;
  age_restrictions: number;
  distributor: {
    id: number;
    name: string;
    icon_svg: string;
  } | null;
  original_name: string;
  trailers: ContentTrailer[];
  index: number;
}

export interface ContentTrailer {
  id: number;
  picture: Picture;
  trailer_link?: string;
}

export interface Distributor {
  id: number;
  name: string;
  icon_svg: string;
  picture_svg: string;
}

export enum AuthModalState {
  Empty = "",
  Login = "login",
  Password = "password",
  LoginWithCode = "login-with-code",
  RegisterOtp = "check-username",
  SetNewPassword = "set-new-password",
  UsernameForReset = "username-for-reset-password",
  ConfirmCodeForReset = "confirm-code-for-reset-password",
  ResetPassword = "reset-password",
}

export enum PasswordModalState {
  Empty = "",
  changePassword = "change-password",
}
